import { Badge as ChakraBadge, BadgeProps as ChakraBadgeProps, forwardRef } from '@chakra-ui/react';
import Icon, { TypeIconName } from '../Icon/Icon';
import Text from '../Text/Text';

export type BadgeColorScheme =
  | 'neutral'
  | 'info'
  | 'positive'
  | 'negative'
  | 'warning'
  | 'progress'
  | 'orange'
  | 'turquoise';
export interface BadgeProps extends ChakraBadgeProps {
  children?: string | number;
  colorScheme?: BadgeColorScheme;
  iconName?: TypeIconName;
  variant?: 'bold' | 'subtle';
}

/**
 * Badges are used to highlight an item's status for quick recognition.
 */
const Badge = forwardRef<BadgeProps, 'span'>((props, ref) => {
  const { children, iconName, ...rest } = props;
  return (
    <ChakraBadge {...rest} ref={ref} paddingInlineStart={iconName ? '4' : '8'} paddingInlineEnd={children ? '8' : '4'}>
      {!!iconName && <Icon size="16" name={iconName} />}
      {!!children && (
        <Text hasEllipsis as="span">
          {children}
        </Text>
      )}
    </ChakraBadge>
  );
});

export default Badge;
